const searchIcon = document.querySelector(".search-icon");
const searchOverlay = document.querySelector(".search-overlay");
const languageSelector = document.querySelector(".disclosure__list");
const languageSelectorButton = document.querySelector(".disclosure__button");
const menuButton = document.querySelector("#Hamburger");
const languageMenu = document.querySelector(".lanquage-overlay");
const cartButton = document.querySelector("#CartItemCount");

searchIcon.addEventListener("click", () => {
  searchOverlay.classList.toggle("search-overlay-active");
  languageSelector.classList.remove("selector-active");
  languageMenu.classList.remove("lanquage-menu-active");
});

const searrchInput = document.querySelector(".search-input");

searrchInput.addEventListener("submit", (e) => {
  searchOverlay.classList.remove("search-overlay-active");
});

languageSelectorButton.addEventListener("click", () => {
  searchOverlay.classList.remove("search-overlay-active");
  languageMenu.classList.toggle("lanquage-menu-active");
});

menuButton.addEventListener("click", () => {
  searchOverlay.classList.remove("search-overlay-active");
  languageSelector.classList.remove("selector-active");
  languageMenu.classList.remove("lanquage-menu-active");
});

cartButton.addEventListener("click", () => {
  languageSelector.classList.remove("selector-active");
  languageMenu.classList.remove("lanquage-menu-active");
  searchOverlay.classList.remove("search-overlay-active");
});
